// Copyright (c) 2018 Deere & Company

import CourierInfo, {getDefaultState as getDefaultCourierInfoState} from '@deere/cps-it.warranty-model-factory/lib/courier-info';
import ReturnStatus, {getDefaultState as getDefaultReturnStatusState} from '@deere/cps-it.warranty-model-factory/lib/return-status';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import PartReturnQuestion from '@deere/cps-it.warranty-model-factory/lib/part-return-question';
import t from 'tcomb';

const InformationRequestForm = t.struct({
    courierInfo: CourierInfo,
    files: t.list(File, 'Files'),
    questions: t.list(PartReturnQuestion, 'Questions'),
    returnStatus: ReturnStatus
}, 'InformationRequestForm');

export const getDefaultState = () => new InformationRequestForm({
    courierInfo: getDefaultCourierInfoState(),
    files: [],
    questions: [],
    returnStatus: getDefaultReturnStatusState()
});

export default InformationRequestForm;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/state/information-request-form.js